import React, { forwardRef, memo } from "react";
import { useTheme } from "styled-components";

function CircleIcon(props: React.HTMLAttributes<SVGSVGElement>, ref: React.Ref<SVGSVGElement>) {
    const theme = useTheme();
    const strokeColor = theme.colors[theme.colorMode].special_positive;

    return (
        <svg
            ref={ref}
            fill="none"
            viewBox="0 0 48 48"
            width="48px"
            height="48px"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="24" cy="24" r="24" fill="#fff"></circle>
            <path
                stroke={strokeColor}
                d="M 24 16 L 32 24 L 24 32"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{
                    opacity: "calc(1 - var(--swipe-progress, 0))",
                }}
            ></path>
            <path
                stroke={strokeColor}
                d="M 15 16 L 23 24 L 15 32"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeOpacity={0.4}
                style={{
                    opacity: "calc(1 - var(--swipe-progress, 0))",
                }}
            ></path>

            <path
                d="M 32.5 18 L 21.571 28.929 C 21.532 28.968 21.468 28.968 21.429 28.929 L 16 23.5"
                stroke={strokeColor}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{
                    opacity: "var(--swipe-progress, 0)",
                }}
                transform="matrix(0, -1, 1, 0, 0.770876, 47.729128)"
            />
        </svg>
    );
}

export default memo(forwardRef(CircleIcon));
